<template>
  <div class="content-area">
    <div
      class=" px-8 pt-8"
      style="width: 100%;"
    >
      <div
        class="d-flex align-center justify-space-between"
        style="width: 100%;"
      >
        <div
          class="d-flex align-center"
          style="gap: 8px;"
        >
          <v-icon color="info">
            {{ icons.mdiLocationEnter }}
          </v-icon>
          <span>Checklist de fim de viagem</span>
          <div class="badge-container">
            <div
              class="badge"
              :style="getBadgeChecklistColor(checklistStatus)"
            >
              <span>{{ checklistStatus }}</span>
            </div>
          </div>
        </div>
        <div
          class="d-flex align-center"
          style="gap: 10px;"
        >
          <v-icon color="#E7E3FC">
            {{ icons.mdiCarHatchback }}
          </v-icon>
          <span>Veículo: <strong style="color: #E7E3FC; background: #E7E3FC1A; font-size: 14px; font-weight: 600; border-radius: 30px; padding: 5px 3.5px;">{{ solicData.vehicle.car_plate }}</strong> - {{ solicData.vehicle.manufacturer.name }} {{ solicData.vehicle.model }}</span>
        </div>
      </div>
      <ChecklistProgressBar
        :total-items="totalItems"
        :completed-items="completedItems"
        :ok-items="okItems"
        :not-ok-items="notOkItems"
      />

      <div
        v-if="!checklistStarted && solicData.status !== 'Finalizada' && solicData.status !== 'Cancelada'"
        class="d-flex flex-column align-center py-8"
      >
        <v-btn
          color="info"
          :disabled="!departureCompleted || (isChild && !checklistId)"
          @click="startChecklist"
        >
          <div
            class="d-flex align-center"
            style="gap: 10px;"
          >
            <v-icon>{{ icons.mdiCheckCircleOutline }}</v-icon>
            <span>{{ startButtonText }}</span>
          </div>
        </v-btn>
      </div>

      <section
        v-if="checklistStarted"
        class="checklist-section"
        :class="{ 'is-animating': isAnimating }"
      >
        <ChecklistItemComponent
          v-for="(item, index) in ChecklistItens"
          :key="index"
          :item="item"
          :index="index"
          :disabled="isChecklistFinalized || isChild"
          @view-problem="handleViewProblem"
        />
        <ChecklistApprovalArea
          v-if="isChecklistFinalized && !isChecklistApproved && !isChild"
          :checklist-id="checklistId"
          :has-non-conform-items="notOkItems > 0"
          checklist-type="end"
          @approve="handleChecklistApprove"
          @disapprove="handleChecklistDisapprove"
        />
        <ChecklistReviewedArea
          v-if="isChecklistReviewed"
          :is-approved="isChecklistApproved"
          :reviewer="checklistData.reviewer"
        />
        <div
          class="d-flex"
          style="width: 100%;"
        >
          <div style="width: 50%;">
          </div>
          <div
            style="width: 50%;"
            class="d-flex justify-space-between"
          >
            <v-btn
              color="success"
              icon
              outlined
              @click="closeChecklist"
            >
              <div
                class="d-flex align-center"
                style="gap: 10px;"
              >
                <v-icon>{{ icons.mdiChevronUp }}</v-icon>
              </div>
            </v-btn>
            <v-btn
              v-if="!isChecklistFinalized && !isChild"
              color="info"
              :disabled="totalItems !== completedItems"
              @click="handleSaveChecklist"
            >
              <span>{{ totalItems === completedItems ? 'SALVAR CHECKLIST' : 'COMPLETE TODOS OS ITENS' }}</span>
            </v-btn>
          </div>
        </div>
      </section>
    </div>
    <v-dialog
      v-model="ShowNotAccordingToModal"
      max-width="632px"
      transition="dialog-transition"
    >
      <NotAccordingToModal
        :item-name="selectedItemName"
        :column-name="selectedColumnName"
        :checklist-id="checklistId"
        @close="ShowNotAccordingToModal = false"
        @problem-reported="handleProblemReported"
      />
    </v-dialog>

    <v-dialog
      v-model="ShowOdometerModal"
      max-width="600px"
      transition="dialog-transition"
    >
      <OdometerModal
        title="Quilometragem final"
        input-label="Km final"
        placeholder="Digite a quilometragem final"
        :checklist-id="checklistId"
        @close="ShowOdometerModal = false"
        @odometer-approved="handleOdometerSaved"
      />
    </v-dialog>
    <v-dialog
      v-model="ShowRegisterFuelSuplyModal"
      max-width="650px"
      transition="dialog-transition"
    >
      <ChecklistFuelSupplyModal
        :vehicle-id="solicData.vehicle.id"
        @close="ShowRegisterFuelSuplyModal = false"
        @save="handleFuelSupplySave"
      />
    </v-dialog>
    <v-dialog
      v-model="ShowProblemViewModal"
      max-width="632px"
      transition="dialog-transition"
    >
      <NotAccordingToModalView
        :key="problemViewModalKey"
        :item-name="selectedItemName"
        :column-name="selectedColumnName"
        :checklist-id="checklistId"
        @close="ShowProblemViewModal = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import axiosIns from '@/plugins/axios'
import {
  mdiBarrel,
  mdiCarBrakeAlert,
  mdiCarHatchback, mdiCarSeat, mdiCarSide, mdiCarTireAlert,
  mdiCheckCircleOutline,
  mdiChevronUp,
  mdiCogs,
  mdiGasStationOutline, mdiLightbulbOnOutline, mdiLocationEnter, mdiPlay, mdiShieldAlertOutline, mdiSpeedometer,
  mdiThumbDown, mdiThumbDownOutline, mdiThumbUp, mdiThumbUpOutline,
  mdiWaterOutline,
} from '@mdi/js'
import { getBadgeChecklistColor } from '../../../helpers/badgeHelpers'
import { CHECKLIST_FIELD_MAPPING, CHECKLIST_PROBLEM_FIELD_MAPPING } from '../../../helpers/checklistFieldMapping'
import ChecklistApprovalArea from './ChecklistApprovalArea.vue'
import ChecklistItemComponent from './ChecklistItemComponent.vue'
import ChecklistProgressBar from './ChecklistProgressBar.vue'
import ChecklistReviewedArea from './ChecklistReviewedArea.vue'
import ChecklistFuelSupplyModal from './modals/ChecklistFuelSupplyModal.vue'
import NotAccordingToModal from './modals/NotAccordingToModal.vue'
import NotAccordingToModalView from './modals/NotAccordingToModalView.vue'
import OdometerModal from './modals/OdometerModal.vue'

export default {
  name: 'ArrivalChecklistComponent',
  components: {
    ChecklistApprovalArea,
    ChecklistReviewedArea,
    ChecklistProgressBar,
    ChecklistItemComponent,
    NotAccordingToModal,
    NotAccordingToModalView,
    OdometerModal,
    ChecklistFuelSupplyModal,
  },
  props: {
    solicData: {
      type: Object,
      default: () => ({}),
    },
    departureCompleted: {
      type: Boolean,
      default: false,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      getBadgeChecklistColor,
      icons: {
        mdiPlay, mdiLocationEnter, mdiCarHatchback, mdiThumbDown, mdiThumbDownOutline, mdiThumbUp, mdiThumbUpOutline, mdiCheckCircleOutline, mdiChevronUp,
      },
      checklistStarted: false,
      isAnimating: false,
      ShowNotAccordingToModal: false,
      ShowOdometerModal: false,
      ShowRegisterFuelSuplyModal: false,
      ShowProblemViewModal: false,
      selectedItemName: '',
      selectedColumnName: '',
      currentOdometerItem: null,
      checklistData: null,
      checklistId: null,
      ChecklistItens: [
        {
          title: 'Abastecimento',
          subtitle: 'Lançar abastecimento final do veículo',
          icon: mdiGasStationOutline,
          iconColor: '#C48EFF',
          isChecked: null,
          data: null,
          onApproved: this.handleFuelSupplyApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Hodômetro',
          subtitle: 'Registrar quilometragem final',
          icon: mdiSpeedometer,
          iconColor: '#C48EFF',
          isChecked: null,
          data: null,
          onApproved: this.handleOdometerApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Estado Externo do Veículo',
          subtitle: 'Verificar lataria, para-choques, limpador de para-brisa, espelhos e vidros',
          icon: mdiCarSide,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Estado Interno do Veículo',
          subtitle: 'Verificar bancos, painel, volante e sistemas internos',
          icon: mdiCarSeat,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Estado dos Pneus',
          subtitle: 'Verificar condições dos pneus após a viagem',
          icon: mdiCarTireAlert,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Sistema de Iluminação',
          subtitle: 'Verificar se faróis, setas e luzes estão funcionando',
          icon: mdiLightbulbOnOutline,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Sistema de Freios',
          subtitle: 'Verificar funcionamento dos freios',
          icon: mdiCarBrakeAlert,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Fluidos do Veículo',
          subtitle: 'Verificar níveis de óleo, água e outros fluidos',
          icon: mdiWaterOutline,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Arla',
          subtitle: 'Verificar níveis e presença no veículo',
          icon: mdiBarrel,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Plataforma hidráulica',
          subtitle: 'Verificar funcionamento e óleo',
          icon: mdiCogs,
          iconColor: '#16B1FF',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
        {
          title: 'Equipamentos de Segurança',
          subtitle: 'Confirmar presença de triângulo, extintor, cabo de ponte',
          icon: mdiShieldAlertOutline,
          iconColor: '#56CA00',
          isChecked: null,
          data: null,
          onApproved: this.handleGenericApproved,
          onRejected: this.handleGenericRejected,
        },
      ],
    }
  },
  computed: {
    totalItems() {
      return this.ChecklistItens.length
    },
    completedItems() {
      return this.ChecklistItens.filter(item => item.isChecked !== null).length
    },
    okItems() {
      return this.ChecklistItens.filter(item => item.isChecked === true).length
    },
    notOkItems() {
      return this.ChecklistItens.filter(item => item.isChecked === false).length
    },
    isChecklistComplete() {
      return this.ChecklistItens.every(item => item.isChecked !== null)
    },
    checklistStatus() {
      if (!this.checklistData) return 'Aguardando'

      if (this.isChecklistApproved) return 'Concluído'
      if (this.isChecklistReviewed) return 'Reprovado'
      if (this.checklistData.items_completed) return 'Em andamento'
      if (this.checklistData.pending_items_count > 0 && this.completedItems > 0) return 'Em andamento'

      return 'Aguardando'
    },
    startButtonText() {
      // Se o checklist está aprovado, mostra "Visualizar Checklist"
      if (this.isChecklistApproved) {
        return 'Visualizar Checklist'
      }

      // Se o checklist já existe e está finalizado, mostra "Revisar e Aprovar"
      if (this.checklistId && this.isChecklistFinalized) {
        return 'Revisar e Aprovar'
      }

      // Se o checklist existe mas não está finalizado, mostra "Revisar Checklist"
      if (this.checklistId) {
        return 'Revisar Checklist'
      }

      // Se o checklist não existe, mostra "Iniciar Checklist"

      return 'Iniciar Checklist'
    },
    isChecklistFinalized() {
      // Verifica se o checklist foi finalizado (items_completed = true)
      return this.checklistData && this.checklistData.items_completed === true
    },
    isChecklistReviewed() {
      // O backend pode enviar is_approved antes da revisão; só há reviewer após aprovar/recusar
      return !!(this.checklistData && this.checklistData.reviewer)
    },
    isChecklistApproved() {
      return this.isChecklistReviewed && this.checklistData.is_approved === true
    },
    problemViewModalKey() {
      // Gera uma key única para forçar recriação do modal
      return `problem-view-${Date.now()}-${Math.random()}`
    },
  },
  mounted() {
    this.loadChecklistData()
  },
  methods: {
    async loadChecklistData() {
      try {
        const tripId = this.solicData.id
        const { data } = await axiosIns.get(`/api/v1/solicitations/transport_vehicle_checklist/get_by_trip_id/${tripId}`)

        // Verifica se o checklist de chegada existe e não é um array vazio
        if (data && data.data && data.data.end && !Array.isArray(data.data.end)) {
          this.checklistData = data.data.end
          this.checklistId = this.checklistData.id
          this.mapChecklistDataToItems()
        } else {
          // Se end for um array vazio, significa que o checklist não foi iniciado
          this.checklistData = null
          this.checklistId = null
        }
      } catch (error) {
        console.error('Erro ao carregar dados do checklist:', error)
      }
    },

    mapChecklistDataToItems() {
      if (!this.checklistData) return

      this.ChecklistItens.forEach((item, index) => {
        const backendField = CHECKLIST_FIELD_MAPPING[item.title]
        if (backendField && this.checklistData[backendField] !== null) {
          this.ChecklistItens[index].isChecked = this.checklistData[backendField]
        }
      })
    },

    async startChecklist() {
      try {
        // Se o checklist ainda não existe (checklistId é null), cria um novo
        if (!this.checklistId) {
          const payload = {
            trip_id: this.solicData.id,
          }

          const { data } = await axiosIns.post('/api/v1/solicitations/transport_vehicle_checklist/store', payload)

          // Se o checklist foi criado, salva o ID e carrega os dados
          if (data && data.data && data.data.id) {
            this.checklistId = data.data.id
            this.checklistData = data.data
          }
        }

        // Inicia a visualização do checklist (seja novo ou existente)
        this.checklistStarted = true
        this.$emit('start-arrival-checklist')

        this.$nextTick(() => {
          setTimeout(() => {
            this.isAnimating = true
          }, 50)
        })
      } catch (error) {
        console.error('Erro ao iniciar checklist:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível iniciar o checklist. Tente novamente.',
        })
      }
    },
    closeChecklist() {
      this.isAnimating = false

      setTimeout(() => {
        this.checklistStarted = false
      }, 700)
    },
    handleGenericApproved(item) {
      const updatedItem = { ...item, isChecked: true }
      const index = this.ChecklistItens.findIndex(i => i.title === item.title)
      this.ChecklistItens.splice(index, 1, updatedItem)
      this.approveItemOnBackend(item.title)
    },

    handleFuelSupplyApproved() {
      this.ShowRegisterFuelSuplyModal = true
    },

    handleFuelSupplySave(data) {
      const updatedItem = {
        ...this.ChecklistItens.find(i => i.title === 'Abastecimento'),
        isChecked: true,
        data,
      }
      const index = this.ChecklistItens.findIndex(i => i.title === 'Abastecimento')
      this.ChecklistItens.splice(index, 1, updatedItem)
      this.approveItemOnBackend('Abastecimento')
      this.ShowRegisterFuelSuplyModal = false
    },

    handleGenericRejected(item) {
      this.selectedItemName = item.title
      this.selectedColumnName = CHECKLIST_PROBLEM_FIELD_MAPPING[item.title] || item.title
      this.ShowNotAccordingToModal = true
    },

    handleProblemReported() {
      // Atualiza o item no checklist como rejeitado
      const item = this.ChecklistItens.find(i => i.title === this.selectedItemName)
      if (item) {
        const updatedItem = {
          ...item,
          isChecked: false,
        }
        const index = this.ChecklistItens.findIndex(i => i.title === item.title)
        this.ChecklistItens.splice(index, 1, updatedItem)
      }

      // Recarrega os dados do checklist
      this.loadChecklistData()
    },

    handleOdometerApproved(item) {
      this.ShowOdometerModal = true
      this.currentOdometerItem = item
    },

    async handleSaveChecklist() {
      if (this.isChecklistComplete) {
        try {
          // Marca o checklist como completo
          const payload = {
            items_completed: true,
          }

          await axiosIns.put(`/api/v1/solicitations/transport_vehicle_checklist/update/${this.checklistId}`, payload)
          this.checklistData = { ...this.checklistData, items_completed: true }

          this.$emit('save-arrival-checklist', this.ChecklistItens)

          this.$swal({
            icon: 'success',
            title: 'Sucesso',
            text: 'Checklist completado com sucesso!',
            showConfirmButton: false,
            timer: 4000,
          })

          // Recarrega os dados
          await this.loadChecklistData()
        } catch (error) {
          console.error('Erro ao salvar checklist:', error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível salvar o checklist. Tente novamente.',
          })
        }
      } else {
        this.$swal({
          icon: 'warning',
          title: 'Atenção',
          text: 'Por favor, complete todos os itens do checklist antes de salvar.',
        })
      }
    },

    async handleChecklistApprove(data) {
      // Recarrega os dados para atualizar o status
      await this.loadChecklistData()

      // Emite evento para o componente pai
      this.$emit('checklist-approved', data)
    },

    async handleChecklistDisapprove(data) {
      // Recarrega os dados para atualizar o status
      await this.loadChecklistData()

      // Emite evento para o componente pai
      this.$emit('checklist-disapproved', data)
    },

    handleProblemReport(reportData) {
      const updatedItem = {
        ...this.ChecklistItens.find(i => i.title === reportData.itemName),
        isChecked: false,
        data: reportData,
      }
      const index = this.ChecklistItens.findIndex(i => i.title === reportData.itemName)
      this.ChecklistItens.splice(index, 1, updatedItem)

      this.rejectItemOnBackend(reportData.itemName)
    },

    async handleOdometerSave(data) {
      if (this.currentOdometerItem) {
        try {
          const payload = {
            km: data.mileage,
            checklist_id: this.checklistId,
          }

          await axiosIns.post('/api/v1/solicitations/transport_vehicle_checklist_km/store', payload)

          const updatedItem = {
            ...this.currentOdometerItem,
            isChecked: true,
            data,
          }
          const index = this.ChecklistItens.findIndex(i => i.title === this.currentOdometerItem.title)
          this.ChecklistItens.splice(index, 1, updatedItem)

          await this.approveItemOnBackend(this.currentOdometerItem.title)

          this.$swal({
            icon: 'success',
            title: 'Sucesso',
            text: 'Quilometragem registrada com sucesso!',
          })
        } catch (error) {
          console.error('Erro ao registrar quilometragem:', error)
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Não foi possível registrar a quilometragem. Tente novamente.',
          })
        }
      }
      this.ShowOdometerModal = false
      this.currentOdometerItem = null
    },

    async handleOdometerSaved(data) {
      if (this.currentOdometerItem) {
        const updatedItem = {
          ...this.currentOdometerItem,
          isChecked: true,
          data,
        }
        const index = this.ChecklistItens.findIndex(i => i.title === this.currentOdometerItem.title)
        this.ChecklistItens.splice(index, 1, updatedItem)
      }

      await this.loadChecklistData()

      this.ShowOdometerModal = false
      this.currentOdometerItem = null
    },

    async approveItemOnBackend(itemTitle) {
      if (!this.checklistId) {
        console.error('Checklist ID não encontrado')

        return
      }

      const backendField = CHECKLIST_FIELD_MAPPING[itemTitle]
      if (!backendField) {
        console.error(`Campo não mapeado: ${itemTitle}`)

        return
      }

      try {
        const payload = {
          [backendField]: true,
        }

        await axiosIns.put(`/api/v1/solicitations/transport_vehicle_checklist/update/${this.checklistId}`, payload)

        // Recarrega os dados para sincronizar
        await this.loadChecklistData()
      } catch (error) {
        console.error('Erro ao aprovar item no backend:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível aprovar o item. Tente novamente.',
        })
      }
    },

    async rejectItemOnBackend(itemTitle) {
      if (!this.checklistId) {
        console.error('Checklist ID não encontrado')

        return
      }

      const backendField = CHECKLIST_FIELD_MAPPING[itemTitle]
      if (!backendField) {
        console.error(`Campo não mapeado: ${itemTitle}`)

        return
      }

      try {
        const payload = {
          [backendField]: false,
        }

        await axiosIns.put(`/api/v1/solicitations/transport_vehicle_checklist/update/${this.checklistId}`, payload)

        // Recarrega os dados para sincronizar
        await this.loadChecklistData()
      } catch (error) {
        console.error('Erro ao rejeitar item no backend:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível rejeitar o item. Tente novamente.',
        })
      }
    },

    handleViewProblem(item) {
      this.selectedItemName = item.title
      this.selectedColumnName = CHECKLIST_PROBLEM_FIELD_MAPPING[item.title] || item.title
      this.ShowProblemViewModal = true
    },

  },
}
</script>

<style scoped>
.checklist-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 28px;
  border-radius: 10px;
  background: #3B355A;
  border: 1px solid #534D74;
}
.arrival-checklist {
  color: #E7E3FC;
  width: 100%;
}

.content-area {
  min-height: 175px;
  box-shadow: 0px 0px 10px 0px #00000040;
  border-radius: 10px;
  background: #312D4B;
  display: flex;
  gap: 49px;
}

.badge {
  padding: 3px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  font-weight: 600;
  text-align: center;
  font-size: 11px;
}
.badge-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

/* Animação manual lenta e fluída para a descida do checklist */
.checklist-section {
  opacity: 0;
  max-height: 0;
  overflow: hidden;
  transform: translateY(-50px);
  transition: all 0.7s ease-in-out;
  display: flex;
  flex-direction: column;
  padding: 32px 0;
  gap: 16px;
}

.checklist-section.is-animating {
  opacity: 1;
  max-height: 5000px;
  transform: translateY(0);
}
</style>
